import { io, Socket } from 'socket.io-client';

import { parseJwt } from '../helpers/settings';

export let socket: Socket | null = null;

export const useSocket = () => {
  return {
    socket,
  };
};

export const createWebsocketConnect = async (
  token: string,
  updateCallback?: (notification) => void,
  nullCallback?: (notification) => void,
): Promise<boolean> => {
  if (!token) return false;
  const data = parseJwt(token);
  if (data && data.user_id && data.nickname) {
    const WS_URL =
      process.env.REACT_APP_WS_URL +
      (process.env.REACT_APP_API_DOMAIN ||
        (window.location.host.endsWith('.com') ? 'skycryptome.com' : 'skycrypto.me'));

    socket = io(WS_URL, {
      path: '/sky-socket',
      reconnectionAttempts: 3,
      timeout: 3000,
      auth: { id: data.user_id, name: data.nickname },
    });

    await new Promise((resolve) => {
      socket.on('connect', () => {
        resolve(true);
      });
      socket.on('connect_error', () => {
        resolve(false);
      });
    });

    updateCallback && socket.on('update deal', updateCallback);
    updateCallback && socket.on(null, nullCallback);
  }
  return false;
};
